/**
 * Theme — design tokens shared by every SDK UI element.
 *
 * Game code can read these to keep its own UI consistent with the SDK
 * shells (menus, lobby, dialogs).
 */
export const Theme = Object.freeze({
  colors: {
    bg:         0x12131a,
    bgAlt:      0x1c1e2a,
    surface:    0x252839,
    surfaceAlt: 0x2f334a,
    text:       '#f3f4f9',
    textDim:    '#9aa0b8',
    primary:    0x6d8aff,
    primaryHex: '#6d8aff',
    accent:     0xffb84d,
    accentHex:  '#ffb84d',
    danger:     0xff4d6d,
    dangerHex:  '#ff4d6d',
    success:    0x4dff9a,
    successHex: '#4dff9a'
  },

  font: {
    family: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    sizes: { sm: '14px', md: '18px', lg: '24px', xl: '36px', xxl: '52px' }
  },

  spacing: { xs: 4, sm: 8, md: 16, lg: 24, xl: 40 },

  radius: 12,

  // Minimum touch target (Apple Human Interface Guidelines).
  minTouchPx: 44
});
